export enum UpsertManyItemStatus {
  Fail = 'FAIL',
  Ok = 'OK',
}
